import React, { useEffect, useState } from "react";
import {
  List,
  ListItem,
  ListItemText,
  Typography,
  CircularProgress,
  Container,
  Paper,
} from "@mui/material";
import { Link } from "react-router-dom";
import { getFirestore, collection, query, where, getDocs } from "firebase/firestore";
import { auth } from "../config/firebase";
import { Match } from "./utils/MatchUtils";

const PlayerMatches: React.FC = () => {
  const [matches, setMatches] = useState<Match[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchMatches = async () => {
      if (!auth.currentUser) return;

      try {
        const db = getFirestore();
        const matchesRef = collection(db, "matches");
        const matchesQuery = query(matchesRef, where("uids", "array-contains", auth.currentUser.uid));
        const matchesSnap = await getDocs(matchesQuery);

        const fetchedMatches: Match[] = matchesSnap.docs.map((doc) => ({
          ...doc.data() as Match,
          id: doc.id,
        })) as Match[];

        setMatches(fetchedMatches);
      } catch (err) {
        setError("Failed to fetch matches.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchMatches();
  }, [auth.currentUser]);

  if (error) return <Typography color="error">{error}</Typography>;
  if (!auth.currentUser) return <Typography>Please log in to view your matches.</Typography>;


      return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Paper elevation={3} sx={{ p: 2 }}>
        <Typography variant="h5" gutterBottom>
          Your Matches
        </Typography>
        {matches.length === 0 ? (
          <Typography>No matches found.</Typography>
        ) : (
          <List>
            {matches.map((match) => (
              <ListItem
                key={match.id}
                component={Link}
                to={`/matches/${match.id}`}
                sx={{ textDecoration: "none", color: "inherit" }}
              >
                <ListItemText
                  primary={`Match ${match.id}`}
                  secondary={`Match ID: ${match.id}`}
                />
              </ListItem>
            ))}
          </List>
        )}
      </Paper>
    </Container>
  );
};

export default PlayerMatches;
